export default __webpack_public_path__ + "static/media/homepage-banner-2.d4aed3d9.webp";